import { ReactNode, useMemo } from 'react'
import { createTheme, useTheme, ThemeProvider } from '@mui/material'

export default function ValidationTableThemeProvider({
  children,
}: {
  children: ReactNode
}) {
  const theme = useTheme()
  // This is the easiest way to get the table cards to reflect the same elevation without making
  // tons of the subcomponents have background "transparent"
  const tableTheme = useMemo(() => {
    return createTheme(theme, {
      palette: {
        mode: theme.palette.mode,
        background: {
          default: theme.palette.mode === 'dark' ? '#3a3a3a' : '#fff',
          paper: theme.palette.mode === 'dark' ? '#3a3a3a' : '#fff',
        },
      },
    })
  }, [theme])

  return <ThemeProvider theme={tableTheme}>{children}</ThemeProvider>
}
